import { Mark, mergeAttributes } from '@tiptap/core';

export const DiffDelete = Mark.create({
  name: 'diffDelete',
  priority: 101, // Higher than Strike (default ~100) to win <del> parsing

  parseHTML() {
    return [{ tag: 'del' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['del', mergeAttributes(HTMLAttributes), 0];
  },
});
